import React, { useEffect, useState } from 'react';
import {
  Form,
  Space,
  Divider,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Select
} from 'antd';
import CourseOfferTable from '../courseOffer/CourseOfferTable';
import CourseOfferAdd from '../courseOffer/CourseOfferAdd';
import { getCourses } from '../../services/courseService';
import { getCourseOffers } from '../../services/courseOfferService';
import '../Common/Form.css';
import { useForm } from 'antd/lib/form/Form';
import { COURSE_TYPES, COHORT_TYPES } from '../../utilities/constants';

const { Title } = Typography;
const { Option } = Select;

const CourseOfferList = (props) => {
  const [courses, setCourses] = useState([]);
  const [cohortCourses, setCohortCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [tableData, setTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [visibleAddModal, setVisibleAddModal] = useState(false);
  const [filterForm] = useForm();
  const [isPricingModalVisible, setIsPricingModalVisible] = useState(
    false
  );

  useEffect((e) => {
    getCourses()
      .then((response) => {
        const courseList = response.data.paginatedList;
        let data = [];
        let cohortData = [];
        courseList.forEach((course) => {
          data.push({
            label: course.code,
            value: course.courseId,
            description: course.description,
            customCardMetadata: course.customCardMetadata
          });
          if (COHORT_TYPES.includes(course.mode)) {
            cohortData.push(course.courseId);
          }
        });
        setCourses(data);
        setCohortCourses(cohortData);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
    const selectedCourseCode = sessionStorage.getItem(
      'CourseOfferPageSelectedCourse'
    );
    if (selectedCourseCode) {
      setSelectedCourse(selectedCourseCode);
      getCourseOffersByCourseCode(selectedCourseCode);
    } else {
      fetchCourseOffers();
    }
  }, []);

  useEffect(() => {
    setFilteredCourses(courses);
  }, [courses]);

  const filterItems = (value, originalData, setter) => {
    const filtered = originalData.filter((item) => {
      const substring = item.label.substr(0, value.length);
      return substring.toLowerCase() === value.toLowerCase();
    });
    setter(filtered);
  };

  const getFilteredCourses = (value) => {
    filterItems(value, courses, setFilteredCourses);
  };

  const fetchCourseOffers = (params = {}) => {
    getCourseOffers(0, 0, params)
      .then((response) => {
        const totalCount = response.data.totalCount;
        const courseOfferList = response.data.paginatedList;
        setTableData(courseOfferList);
        setFilteredTableData(courseOfferList);
        setTotalData(totalCount);
      })
      .catch((err) => {
        console.log('Error getting data from backend:', err);
        alert('Getting data from backend failed');
      });
  };

  let getCourseOffersByCourseCode = (selectedCourse) => {
    let params = {};
    if (!!selectedCourse) {
      params = { courseCode: selectedCourse };
    } else {
      alert('Enter a valid courseID');
      return;
    }

    getCourseOffers(0, 0, params)
      .then((response) => {
        setSelectedCourse(selectedCourse);
        sessionStorage.setItem(
          'CourseOfferPageSelectedCourse',
          selectedCourse
        );
        setTableData(response.data.paginatedList);
        setFilteredTableData(response.data.paginatedList);
        setTotalData(response.data.totalCount);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const textChangeHandler = (event) => {
    event.preventDefault();
    console.log(document.getElementById('search-input').value);
  };

  const courseOfferChangeHandler = (event) => {
    event.preventDefault();
    let response = tableData;
    if (document.getElementById('search-course-offer').value !== '') {
      response = tableData.filter((item) => {
        return item.code.includes(
          String(
            document.getElementById('search-course-offer').value
          ).toUpperCase()
        );
      });
    }
    setFilteredTableData(response);
    setTotalData(response.length);
  };

  const onClickModal = () => {
    setVisibleAddModal(true);
  };

  const onSearch = (data) => {
    const params = { [data.param]: data.val };
    fetchCourseOffers(params);
  };

  const onReset = () => {
    filterForm.resetFields();
    localStorage.removeItem('CourseOfferPageSelectedCourse');
    setSelectedCourse('');
    fetchCourseOffers();
  };

  const courseListOptions = courses.map((course, index) => (
    <Option value={course.label} key={index}>
      {course.label} - {course.description}
    </Option>
  ));

  const onCancelModal = () => {
    setVisibleAddModal(false);
    setIsPricingModalVisible(false);
  };

  return (
    <div>
      <div>
        <Form>
          <Row gutter={16}>
            <Col span={4}>
              <Space>
                <Input
                  placeholder="Search Course..."
                  onChange={textChangeHandler}
                  type="text"
                  id="search-input"
                />
              </Space>
            </Col>
            <Col span={10}>
              <Form.Item name="courseCode">
                <Select
                  onChange={getCourseOffersByCourseCode}
                  placeholder={
                    selectedCourse ? selectedCourse : 'Select Course Code'
                  }
                  showSearch={true}
                  onSearch={getFilteredCourses}>
                  {courseListOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      <div>
        <Divider />
        <Space size="large">
          <Title level={3}>Course Offers</Title>
          <Button type="ghost" onClick={onClickModal}>
            Add
          </Button>

          <CourseOfferAdd
            isOpen={visibleAddModal}
            onCancelModal={onCancelModal}
            courses={courses}
            cohortCourses={cohortCourses}
            isPricingModalVisible={isPricingModalVisible}
            setIsPricingModalVisible={setIsPricingModalVisible}
          />
        </Space>

        <section className="grey-section">
          <Form
            form={filterForm}
            onFinish={onSearch}
            initialValues={{ param: 'code' }}>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item name="param" rules={[{ required: true }]}>
                  <Select placeholder="Search by..." defaultValue="code">
                    <Option value="code">Code</Option>
                    <Option value="wave">Wave</Option>
                    <Option value="description">Description</Option>
                    <Option value="courseOfferId">ID</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item name="val" rules={[{ required: true }]}>
                  <Input placeholder="Enter the search term..." />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                  <Button htmlType="button" onClick={onReset}>
                    Reset
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </section>
        <Title level={5}>Total {totalData} Record(s)</Title>
        <section>
          <CourseOfferTable data={filteredTableData} />
        </section>
      </div>
    </div>
  );
};

export default CourseOfferList;
